import React,{ useState} from "react";
//import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import Carousel from 'react-bootstrap/Carousel';
import avatar from '../assests/person-avatar.png';

import img1 from '../assests/TPN.png';
import img2 from '../assests/HGP.png';
import img3 from '../assests/HJV.jpg';
import img4 from '../assests/HTT.png';
import img5 from '../assests/KR.png';

const Testimonial = () => {
    const [tindex, settIndex] = useState(0);

    const handletSelect = (selectedIndex) => {
        settIndex(selectedIndex);
    };

    return (<Carousel className="testList" activeIndex={tindex} onSelect={handletSelect}>
        <Carousel.Item>
        <div className="card">
            <div className="row g-0">
                <div className="col-md-2 p-2">
                    <img src={avatar} className="test-icon-img img-fluid rounded-start p-2" alt="..." />
                </div>
                <div className="col-md-10">
                    <div className="card-body">
                        <h5 className="card-title">Vaseekaran Ramachandran</h5>
                        <p className="card-text">One of the best Accounting service provider, they will take of all GST Filing and notices. Great Job!!!</p>
                    </div>
                </div>
            </div>
        </div>
        </Carousel.Item>
        <Carousel.Item>
        <div className="card">
            <div className="row g-0">
                <div className="col-md-2 p-2">
                    <img src={avatar} className="test-icon-img img-fluid rounded-start p-2" alt="..." />
                </div>
                <div className="col-md-10">
                    <div className="card-body">
                        <h5 className="card-title">Prasanth</h5>
                        <p className="card-text">Good & Experienced Account, very helpful advises. Great Service. Thanks..</p>
                    </div>
                </div>
            </div>
        </div>
        </Carousel.Item>
        <Carousel.Item>
        <div className="card">
            <div className="row g-0">
                <div className="col-md-2 p-2">
                    <img src={avatar} className="test-icon-img img-fluid rounded-start p-2" alt="..." />
                </div>
                <div className="col-md-10">
                    <div className="card-body">
                        <h5 className="card-title">Ramadevi R</h5>
                        <p className="card-text">Resonable charges and wonderfull service. Keep it up.</p>
                    </div>
                </div>
            </div>
        </div>
        </Carousel.Item>
    </Carousel>
    );
};

const OurEvents = () => {
    const [eindex, setEIndex] = useState(0);

    const handleESelect = (selectedIndex) => {
        setEIndex(selectedIndex);
    };

    return (
        <Carousel className="eventList" activeIndex={eindex} onSelect={handleESelect}>
            <Carousel.Item>
            <div className="card">
                <div className="row g-0">
                    <div className="col-md-10">
                        <div className="card-body">
                            <h5 className="card-title">New GST Rates</h5>
                            <p className="card-text">GST Council reviced GST Rate for Food, Grosory and many other products.</p>
                        </div>
                    </div>
                </div>
            </div>
            </Carousel.Item>
            <Carousel.Item>
            <div className="card">
                <div className="row g-0">
                    <div className="col-md-10">
                        <div className="card-body">
                            <h5 className="card-title">SBT ERP <strong>Coming Soon</strong></h5>
                            <p className="card-text">A RBAC saas based product will be launched soon, to handle Stock, Billing & Tax management with single application.</p>
                        </div>
                    </div>
                </div>
            </div>
            </Carousel.Item>
            <Carousel.Item>
            <div className="card">
                <div className="row g-0">
                    <div className="col-md-10">
                        <div className="card-body">
                            <h5 className="card-title">High GST Notice in Motion</h5>
                            <p className="card-text">Due to recent action and analysis GST Notice issuance is increased emensively, beware and address it on regular basis to avoid Penalties</p>
                        </div>
                    </div>
                </div>
            </div>
            </Carousel.Item>
        </Carousel>
    );
};

const getContent = () => {
    return (
    <footer className="">
        <div className="section">
            <div className="row">
                <div className="row mt-3 p-2 border-top shadow">
                    <div className="col-md-6 p-2">
                        <h5 className="above-footer text-center">Testimonials</h5>
                        <Testimonial />
                    </div>
                    <div className="col-md-6 p-2">
                        <h5 className="above-footer text-center">Events</h5>
                        <OurEvents />
                    </div>
                </div>
            </div>
            <div className="row p-2">
                <ul className="logo-scroller">
                    <li className=" rounded"><img src={img1} alt="..." /></li>
                    <li className=" rounded"><img src={img2} alt="..." /></li>
                    <li className=" rounded"><img src={img3} alt="..." /></li>
                    <li className=" rounded"><img src={img4} alt="..." /></li>
                    <li className=" rounded"><img src={img5} alt="..." /></li>
                </ul>
            </div>
        </div>
      <p className="bg-dark text-white text-center py-1">&copy; 2025 Sri Amman Associates. All rights reserved.</p>
    </footer>
  );
};

export default getContent;